import { MediaDesktop, MediaTablet } from "api/const/MediaQuery"
import { Button, Loader } from "components/atoms"
import CardPreview from "components/atoms/CardPreview"
import XmarkIcon from "components/atoms/iconsComponent/XmarkIcon"
import { PagerComponent } from "components/molecules/pagination/PagerComponent"
import { MessagesListReq } from "components/types/Api"
import { LoginType } from "components/types/Context"
import { Match } from "components/types/types"
import useMediaQuery from "hook/useMediaQuery"
import { useCallback, useContext, useEffect, useMemo, useState } from "react"
import { Link, useLocation, useNavigate } from "react-router-dom"
import { AppGeneralContext } from "shared/GeneralContext/GeneralContext"
import { PAGE_SIZE } from "shared/const"

export const ChatMobilePage = () => {
    const { matchList,
        loginType,
        reqMessagesList,
        reqMatchList,
        setReqMessagesList,
        setReqMatchList,
        setMatchSelected,
        getMatchList,
        pagerMatchList,
        isLoadingMatch
    } = useContext(AppGeneralContext)
    const [filterByText, setFilterByText] = useState<string>("")
    const message = useMemo(() => matchList, [matchList])
    const navigate = useNavigate()
    const route = loginType === LoginType.startup ? 'start-up' : "corporate"
    const location = useLocation()
    const tablet = useMediaQuery(MediaTablet)

    const updatePage = useCallback(
        (n: number) => {
            setReqMatchList({ ...reqMatchList, pageNum: n, pageSize: PAGE_SIZE.matchListMobile })
        }, [reqMatchList])

    useEffect(() => {
        setReqMatchList({ ...reqMatchList, searchText: filterByText })
    }, [filterByText])


    useEffect(() => {
        getMatchList()
    }, [reqMatchList])

    const clickHandler = (id: string, match: Match) => {
        let RequestMessageList: MessagesListReq = { ...reqMessagesList, matchId: id }
        setReqMessagesList(RequestMessageList)
        setMatchSelected(match)
        navigate(`/${route}/profile/messaging/${match.id}`)
    }

    const showChat = useMemo(() => {
        if (message && message.length !== 0) {
            return message.map((el) => {
                return <CardPreview
                    key={el.id}
                    id={el.id}
                    recipient={loginType === LoginType.startup ? el.company?.name : el.startup?.name}
                    hasImage={loginType === LoginType.startup ? true : false}
                    date={el?.lastMessageDate}
                    department={loginType === LoginType.startup ? el.companyDepartment?.label : el.startup.sector?.label}
                    readMatch={loginType === LoginType.startup ? el?.isReadStartup : el?.isReadCompany}
                    callback={() => {
                        clickHandler(el.id, el)
                    }}
                />
            })
        } else {
            return <p>You have no messages</p>
        }

    }, [message, loginType])


    return (
        <div className="">
            <div className="d-flex flex-column search-container pt-3">
                <Link to={`/${route}/profile`} className=" link d-flex w-100 search-info justify-content-between align-items-center">
                    <h4 className="">{"< Profile  "}</h4>
                </Link>
                <div className="relative ">
                    <input
                        placeholder='Search by name'
                        className="form-input"
                        autoComplete="off"
                        value={filterByText}
                        type="text"
                        onChange={(x) => setFilterByText(x.target.value)}
                        name="search"
                    />
                    <div className="delete-input  " onClick={() => setFilterByText("")}>
                        <XmarkIcon className='w-100' />
                    </div>
                </div>
            </div>
            <div className="d-flex mt-3 flex-column   ">
                {showChat}
                {isLoadingMatch &&
                    <Loader />
                }
                {pagerMatchList && pagerMatchList?.totalItems && pagerMatchList?.totalItems > PAGE_SIZE.matchList &&
                    <PagerComponent pager={pagerMatchList} onpageChange={(n: number) => { updatePage(n) }} classCss={"mt-5"} />}
            </div>
        </div>
    )
}